var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"regular",class:{
      'text-center': _vm.nameCenter,
    }},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"text-black",class:{
      'text-center': _vm.textCenter,
      bold: _vm.bold,
    }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }